import React from 'react'
import { InputHLPure } from '../../../../pures';

function InputPureWrapper(fieldRenderProps) {
    const { id, label, value, onChange, visited, validationMessage, ...otherProps } = fieldRenderProps;

    return (
        <InputHLPure
            id={id}
            labelInput={label}
            valueInput={value}
            handleChangeInput={onChange}
            errorInput={visited && validationMessage}
            errorInputText={validationMessage}
            {...otherProps}
        />
    );
};

export default InputPureWrapper